/**
 * Default display order for scheme columns in the Order Execution dashboard.
 *
 * Reorder this array to change the default column sequence.
 * Users can override at runtime via drag-and-drop; their
 * preference is persisted in localStorage.
 *
 * Schemes not listed here are appended at the end in alphabetical order.
 *
 * Active schemes:
 *   AIF_IEF   — Sameeksha India Equity Fund (AIF)
 *   AIF_SLHF  — Sameeksha Long Horizon Fund (AIF)
 *   CIEP      — Concentrated India Equity Portfolio (PMS)
 *   IEF       — India Equity Fund (PMS)
 *   IOE       — India Opportunistic Equities Portfolio
 *   SCPL      — Sameeksha Capital Global PMS
 *   SIDI      — India Diversified Investment Strategy (PMS)
 *   SIFEF     — India Flexicap Equity Fund (AIF)
 *   SILH      — India Long Horizon Fund (PMS)
 *   SIML      — Sameeksha Investment Managers LLP Global PMS
 */
export const DEFAULT_SCHEME_ORDER: string[] = [
  "AIF_IEF",
  "CIEP",
  "SIFEF",
  "SILH",
  "AIF_SLHF",
  "SCPL",
];